import React from 'react';
import { track } from '../lib/analytics';

const Header = () => {
  return (
    <header
      data-testid="site-header"
      className="fixed top-0 left-0 right-0 z-50 flex items-center justify-between"
      style={{
        padding: '20px 24px',
        background: 'rgba(249, 245, 239, 0.9)',
        backdropFilter: 'blur(8px)',
        WebkitBackdropFilter: 'blur(8px)',
        borderBottom: '1px solid var(--yup-border)',
      }}
    >
      <a
        href="#top"
        data-testid="header-logo"
        className="font-serif"
        style={{
          fontSize: '22px',
          fontWeight: 600,
          letterSpacing: '2px',
          color: 'var(--yup-accent)',
          textTransform: 'uppercase',
          textDecoration: 'none',
        }}
        aria-label="YUP — Your Unmasking Process"
      >
        YUP
      </a>

      <nav
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '20px',
          flexWrap: 'nowrap',
        }}
      >
        <a
          href="/assessment"
          data-testid="header-assessment-link"
          onClick={() => track('header_assessment_click')}
          style={{
            fontSize: '11px',
            letterSpacing: '2px',
            textTransform: 'uppercase',
            color: 'var(--yup-accent)',
            textDecoration: 'none',
            borderBottom: '1px solid var(--yup-warm)',
            paddingBottom: '2px',
            transition: 'color 0.2s',
            whiteSpace: 'nowrap',
          }}
          onMouseEnter={(e) => (e.currentTarget.style.color = 'var(--yup-warm)')}
          onMouseLeave={(e) => (e.currentTarget.style.color = 'var(--yup-accent)')}
        >
          Self Assessment →
        </a>
        <a
          href="/supporters"
          data-testid="header-supporters-link"
          onClick={() => track('header_supporters_click')}
          style={{
            fontSize: '11px',
            letterSpacing: '2px',
            textTransform: 'uppercase',
            color: 'var(--yup-muted)',
            textDecoration: 'none',
            transition: 'color 0.2s',
            whiteSpace: 'nowrap',
          }}
          onMouseEnter={(e) => (e.currentTarget.style.color = 'var(--yup-accent)')}
          onMouseLeave={(e) => (e.currentTarget.style.color = 'var(--yup-muted)')}
        >
          For Practitioners
        </a>
      </nav>
    </header>
  );
};

export default Header;
